import { Badge, BlockStack, Box, Button, InlineStack, Text } from '@shopify/polaris'

export type WorkflowCreateItemType = 'single' | 'subscription' | 'tagging'

export const workflowLabels: Record<
  WorkflowCreateItemType,
  { title: string; badgeLabel?: string; createButtonLabel: string }
> = {
  single: {
    title: 'Custom workflow',
    badgeLabel: 'Advanced',
    createButtonLabel: 'Create custom workflow',
  },
  subscription: {
    title: 'Subscription automation',
    badgeLabel: 'New',
    createButtonLabel: 'Create subscription automation',
  },
  tagging: { title: 'Customer tagging', createButtonLabel: 'Create customer tagging' },
}

export const workflowDescriptions: Record<WorkflowCreateItemType, React.ReactNode> = {
  single: (
    <Text as="p">Define arbitrary actions to trigger on specified events and conditions.</Text>
  ),
  subscription: (
    <Text as="p">
      Update your subscriptions after specified billing cycles, for example to add a discount, swap
      or add a product.
    </Text>
  ),
  tagging: (
    <Text as="p">
      Segment your customers by adding and removing tags depending on the current status of their
      subscriptions.
    </Text>
  ),
}

export const WorkflowCreateCard = ({
  type,
  url,
  onClick,
}: {
  type: WorkflowCreateItemType
  url?: string
  onClick?(): unknown
}) => (
  <Box
    minHeight="100%"
    borderWidth="025"
    borderColor="border"
    background="bg-fill"
    borderRadius="200"
    position="relative"
  >
    <Box padding="300" paddingBlockEnd="1600">
      <BlockStack gap="300">
        <InlineStack wrap={false} align="space-between" blockAlign="baseline" gap="200">
          <Text variant="headingMd" as="h2">
            {workflowLabels[type].title}
          </Text>
          {workflowLabels[type].badgeLabel && (
            <Badge tone="attention">{workflowLabels[type].badgeLabel}</Badge>
          )}
        </InlineStack>
        {workflowDescriptions[type]}
      </BlockStack>
    </Box>
    <Box position="absolute" insetBlockEnd="0" width="100%" padding="300" paddingBlockStart="800">
      <Button onClick={onClick} url={url} variant="primary" fullWidth>
        {workflowLabels[type].createButtonLabel}
      </Button>
    </Box>
  </Box>
)
